<div class="content">
  <div class="card">
    <div class="card-content">
      <div class="card-body">
      
        <button *ngIf='!isList' routerLink="/orders" title="{{ 'inputs.back' | translate }}" mat-icon-button>
          <mat-icon>keyboard_backspace</mat-icon>
          {{ 'inputs.back' | translate }}
        </button>

        <h1 *ngIf='isList'>{{ 'titles.list.order-family' | translate }}</h1>
        <h1 *ngIf='!isList'>{{ 'titles.edit.order-family' | translate }} {{reference}}</h1>
        <div *ngIf='!isList && !isNew'>
          <div *ngFor="let photo of product_photo">
            <p style="float: left;">
              <a [href]="photo.imageUrl" target="_blank"><img [src]="photo.imageUrl"></a>
            </p>
            <p> {{ 'inputs.creation_date' | translate }}: {{creation_date | date:'d/M/Y, H:mm:ss'}} <br>
              {{ 'inputs.modification_date' | translate }}: {{modification_date | date:'d/M/Y, H:mm:ss'}}
            </p>

          </div>
          <h2 style="text-align: right;" *ngIf="value">
            {{ 'inputs.value' | translate }}: {{value}} €<br>
            {{ 'inputs.value_shipping' | translate }}: {{value_shipping.toFixed(2)}} €<br>
            Total: {{total.toFixed(2)}} €<br>
            {{ 'inputs.status' | translate }}: {{'status.' + status | translate}}
            <br>
            <br>
          <button mat-raised-button matTooltip="{{'inputs.download_invoice' | translate}}" (click)="downloadInvoice(url_invoice)" *ngIf="(url_invoice)">
            <!-- <mat-icon>download</mat-icon> -->
            <span>{{'inputs.download_invoice' | translate}}</span>
          </button>
          <!-- <button mat-icon-button style="cursor:default; color:lightgray" *ngIf="(!url_invoice)">
            <span>{{'inputs.download_invoice' | translate}}</span>
          </button> -->
          </h2>
          
        </div>
        <div style="clear: left;"></div>

        <div class="media-body">

          <mat-form-field *ngIf='isList'>
            <mat-label>{{ 'inputs.search' | translate }}</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="{{ 'inputs.search' | translate }}" #input>
          </mat-form-field>
          <div *ngIf='isList'>
            <table mat-table [dataSource]="dataSource" matSort matSortActive="creation_date" matSortDirection="desc">

              <ng-container matColumnDef="reference">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.reference' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)"> {{element.reference}} </td>
              </ng-container>

              <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.value' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm> {{element.total.toFixed(2)}} € </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.status' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm > 
                  <div *ngIf="!element.downloaded">
                      {{'status.' + element.status | translate}} 
                  </div>
                  <div *ngIf="element.downloaded">
                      {{'status.' + element.status | translate}} - {{'inputs.downloaded' | translate}} 
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="creation_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.creation_date' |
                  translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm>
                  {{element.creation_date | date: 'yyyy-MM-dd H:mm:ss'}} </td>
              </ng-container>

              <ng-container matColumnDef="actions" class="actionsColumn">
                <th mat-header-cell *matHeaderCellDef> {{ 'tables.actions' | translate }} </th>
                <td mat-cell *matCellDef="let element">
                  <!-- <button mat-icon-button matTooltip="Click to Delete" class="iconbutton"
                  (click)="delete(element.id)" color="warn">
                  <mat-icon>delete</mat-icon>
                </button> -->
                  <button mat-icon-button matTooltip="{{'inputs.cancel_order' | translate}}" (click)="cancelOrder(element.id)" *ngIf="((element.status == 'reserved' || element.status == 'paid') && user_role != 'family')">
                    <span>{{'inputs.cancel_order' | translate}}</span>
                  </button>
                  <button mat-icon-button style="cursor:default; color:lightgray" *ngIf="((element.status != 'reserved' && element.status != 'paid') && user_role != 'family')">
                    <span>{{'inputs.cancel_order' | translate}}</span>
                  </button>
                  <br *ngIf="user_role != 'family'">
                  <button mat-icon-button matTooltip="{{'inputs.download_invoice' | translate}}" (click)="downloadInvoice(element.url_invoice)" *ngIf="(element.url_invoice)">
                    <!-- <mat-icon>download</mat-icon> -->
                    <span>{{'inputs.download_invoice' | translate}}</span>
                  </button>
                  <button mat-icon-button style="cursor:default; color:lightgray" *ngIf="(!element.url_invoice)">
                    <span>{{'inputs.download_invoice' | translate}}</span>
                  </button>
                  <br>
                  <!-- <button mat-icon-button matTooltip="{{'inputs.download_zip' | translate}}"  (click)="downloadZip(element.url_zip)" *ngIf="(element.url_zip)">
                    <span>{{'inputs.download_zip' | translate}}</span>
                  </button> -->
                  <button mat-icon-button matTooltip="{{'inputs.download_zip' | translate}}" (click)="goTo(element.reference)" *ngIf="(element.url_zip)">
                    <span>{{'inputs.download_zip' | translate}}</span>
                  </button>
                  
                    
                  
                </td>
              </ng-container>
              <!-- <ng-container matColumnDef="actions"class="actionsColumn">
                <th mat-header-cell *matHeaderCellDef> {{ 'tables.actions' | translate }} </th>
                <td mat-cell *matCellDef="let element"> 
                  <button mat-icon-button matTooltip="{{'inputs.edit' | translate}}"
                    (click)="goTo(element.id)">
                    <mat-icon>edit</mat-icon>
                  </button>
         
              </td>
              </ng-container> -->





              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  <span *ngIf="showOrderFamilyProgressBar">{{ 'tables.loading' | translate }}</span>
                  <span *ngIf="!showOrderFamilyProgressBar">{{ 'tables.no_data_found' | translate}}</span>
                </td>
              </tr>
            </table>
            <mat-progress-bar *ngIf="showOrderFamilyProgressBar" mode="indeterminate"></mat-progress-bar>
            <mat-paginator [pageSizeOptions]="[100, 10, 20,50]" showFirstLastButtons></mat-paginator>

          </div>
<div *ngIf="showPrimarySpinner" class="spinner-wrapper">
        <mat-spinner class="spinner-inner"></mat-spinner>
      </div>

          <!-- <mat-card *ngIf='!isList'> -->
          <div class="contenedor" *ngIf='!isList'>




            <table mat-table [dataSource]="dataSource2" matSort class="detail">

              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.description' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)"> {{element.description}} </td>
              </ng-container>

              <ng-container matColumnDef="product_name_es">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm
                  style="display: {{'es' | translate}}"> {{ 'tables.product_name' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm
                  style="display: {{'es' | translate}}"> {{element.product_name_es }} </td>
              </ng-container>
              <ng-container matColumnDef="product_name_en">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm
                  style="display: {{'en' | translate}}"> {{ 'tables.product_name' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm
                  style="display: {{'en' | translate}}"> {{element.product_name_en }} </td>
              </ng-container>
              <ng-container matColumnDef="product_name_cat">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm
                  style="display: {{'cat' | translate}}"> {{ 'tables.product_name' | translate }} </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm
                  style="display: {{'cat' | translate}}"> {{element.product_name_cat }} </td>
              </ng-container>
              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.quantity' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm>
                  {{element.quantity }} </td>
              </ng-container>

              <ng-container matColumnDef="value">
                <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.value' | translate }}
                </th>
                <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm> {{element.value}}
                  € </td>
              </ng-container>

              <ng-container matColumnDef="actions"class="actionsColumn">
                  <th mat-header-cell *matHeaderCellDef> {{ 'tables.actions' | translate }} </th>
                  <td mat-cell *matCellDef="let element"> 
                    <!-- <button mat-icon-button matTooltip="{{'inputs.download' | translate}}"
                      (click)="downloadPhoto(element.main_photo, element.id, element.product_name_es)" *ngIf="element.downloadable && (element.status == 'processed' && !element.downloaded)" style="float: right;">
                       <mat-icon>download</mat-icon> {{'inputs.download' | translate}}
                    </button> -->
                    <button mat-icon-button matTooltip="{{'inputs.download' | translate}}"
                      (click)="downloadPhoto(element.main_photo, element.id, element.product_name_es, '', true)" *ngIf="element.downloadable && !element.downloaded" style="float: right;">
                       <mat-icon>download</mat-icon> {{'inputs.download' | translate}}
                    </button>
                    <button mat-icon-button matTooltip="{{'inputs.download' | translate}}"
                      (click)="downloadPhoto(element.main_photo, element.id, element.product_name_es)" *ngIf="element.downloadable && element.downloaded" style="color:black; float:right">
                      <mat-icon>download</mat-icon> {{'inputs.download' | translate}}
                    </button>
          
                </td>
              </ng-container>


              <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" colspan="4">
                  <span *ngIf="showOrderFamilyProgressBar2">{{ 'tables.loading' | translate }}</span>
                  <span *ngIf="!showOrderFamilyProgressBar2">{{ 'tables.no_data_found' | translate}}</span>
                </td>
              </tr>
            </table>
            <mat-progress-bar *ngIf="showOrderFamilyProgressBar2" mode="indeterminate"></mat-progress-bar>
            <mat-paginator [pageSizeOptions]="[100, 10, 20,50]" showFirstLastButtons></mat-paginator>
          </div>
          <!-- </mat-card> -->


          <!-- <div class="float-button-container" *ngIf='isList'>
            <button mat-fab color="primary" aria-label="add" (click)="newCatalogue()">
              <mat-icon>plus_one</mat-icon>
            </button>
          </div>
          <div class="float-button-container" *ngIf='!isList'>
            <button mat-fab color="primary" aria-label="save" (click)="saveCatalogue()">
              <mat-icon>save</mat-icon>
            </button>
          </div> -->
        </div>

      </div>
    </div>
  </div>
  <!--   
    <div class="card" *ngIf='!isList && !isNew'>
        <div class="card-content">
            <div class="card-body">
                <h1 *ngIf='!isList'>{{ 'titles.list.order_family' | translate }}</h1>
                <table mat-table [dataSource]="dataSource2" matSort>
              
                    <ng-container matColumnDef="student_name">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'tables.student_name' | translate }} </th>
                      <td mat-cell *matCellDef="let element"(click)="goTo(element.reference)"> {{element.student_name}} </td>
                    </ng-container>
      
                    <ng-container matColumnDef="product_name">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header  fxHide.lt-sm> {{ 'tables.product_name' | translate }} </th>
                      <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm> {{element.product_name }} </td>
                    </ng-container>
                    <ng-container matColumnDef="quantity">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header  fxHide.lt-sm> {{ 'tables.quantity' | translate }} </th>
                      <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm> {{element.quantity }} </td>
                    </ng-container>
      
                    <ng-container matColumnDef="value">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header fxHide.lt-sm> {{ 'tables.value' | translate }} </th>
                      <td mat-cell *matCellDef="let element" (click)="goTo(element.reference)" fxHide.lt-sm> {{element.value}} € </td>
                    </ng-container>
      
                    <ng-container matColumnDef="actions"class="actionsColumn">
                      <th mat-header-cell *matHeaderCellDef> {{ 'tables.actions' | translate }} </th>
                      <td mat-cell *matCellDef="let element"> 
          
                        <button mat-icon-button matTooltip="{{'inputs.edit' | translate}}"
                          (click)="goTo(element.id)">
                          <mat-icon>edit</mat-icon>
                        </button>
               
                    </td>
                    </ng-container>
                  
              
                    <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns2;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                      <td class="mat-cell" colspan="4">No data found</td>
                  </tr>
                  </table>
              
                  <mat-paginator [pageSizeOptions]="[10, 20,50]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
      </div> -->
</div>